import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/atlante';
export function Testimonials() {
  return <section className="border-y-4 border-navy bg-white px-4 py-5 sm:py-7" data-id="element-192" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-5xl" data-id="element-193" data-mp="3fym68hdq8w2r">
        <h2 className="text-center text-xl leading-tight text-navy sm:text-2xl" data-id="element-194" data-mp="3fxksu698nxhv">
          COSA DICONO I PROFESSIONISTI
        </h2>

        <div className="mt-3 grid gap-2.5 md:grid-cols-2" data-id="element-195" data-mp="36yplgqugkhcz">
          {testimonials.map((t, i) => <figure key={t.author} className={`flex flex-col border border-navy/15 bg-ivory p-4 shadow-sm ${i === 0 ? 'md:col-span-2' : ''}`} data-id="element-196" data-mp="31zd3ajej7ygq" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="Valutazione 5 su 5" data-id="element-197" data-mp="2s2rwptmv6fas">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-198" data-mp="v7ca3gfpznu5" data-mpi={s} />)}
              </div>
              <blockquote className="mt-1.5 text-[13px] font-medium italic leading-snug text-navy sm:text-[14.5px]" data-id="element-199" data-mp="h8axnbsvonq6">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-2 pt-2.5" data-id="element-200" data-mp="79bqxyrob25t">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-navy font-display text-sm font-extrabold text-white" data-id="element-201" data-mp="c7wrjzau7nus">
                  {t.author.charAt(0)}
                </span>
                <span className="leading-tight" data-id="element-202" data-mp="14uzlsf8hdcf8">
                  <span className="block text-[13px] font-extrabold text-navy" data-id="element-203" data-mp="q6wb4sjhtck3">
                    {t.author}
                  </span>
                  <span className="block text-[11px] font-semibold text-slate2" data-id="element-204" data-mp="v4eoqw8ggfyf">
                    {t.role} — {t.location}
                  </span>
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}